/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './PinIcon.style';

import svg from './pin.svg';

type Props = {
  layoutClass?: string,
  title?: string,
  // Self passed
};

const useStyles = createUseStyles(styles);

const PinIcon = ({ layoutClass, title }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, layoutClass)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(PinIcon);
